import './scss/style.scss';

import Vue from 'vue';
import store from './store';
import App from './App.vue';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { save, logX, parseJSON } from './common/libs/utils';
import { init as initGlobalComponents } from './globalComponents';
import { getUser } from './services/user';
import './common/libs/directives';
import { init as initIframer, onMessage, sendMessage } from './common/libs/iframer';
import { setup as setupConfig } from './services/config';
import { requestPV } from './services/pv';

// import { loadChats } from './services/chat';

// const env = process.env;
// process.env = new Proxy(env, {
// 	get(target, prop, receiver) {
// 		return target[prop] = (target[prop] || '').replace(/{(.*?)}/g, (_, e) => eval(e));
// 	}
// });

Vue.use(VueSweetalert2, {
	confirmButtonColor: '#5b1fda',
	cancelButtonColor: '#f3351b'
});

Vue.prototype.$base = process.env.VUE_APP_ROOT_PATH;
Vue.prototype.$log = (...args) => {
	if (['production'].includes(process.env.VUE_APP_MODE)) return;
	console.log(...args.map(e => (typeof e === 'object' ? parseJSON(JSON.stringify(e)) : e)));
};
Vue.prototype.logX = logX;
Vue.prototype.parseJSON = parseJSON;

initGlobalComponents();

const updateHeight = () => {
	let vh = window.innerHeight;
	document.body.style.setProperty('--height', `${vh}px`);
};

window.addEventListener('load', () => {
	updateHeight();
	window.addEventListener('resize', updateHeight);
});

(async () => {
	// setup configuration
	await setupConfig();

	// setup user
	try {
		await getUser();
	} catch (ex) {
		console.error(ex);
	}

	const generateCode = () => {
		const dict = '012345679abcdefghijklmnopqrstuvwxyz';
		let code = `${new Date().getTime().toString(36)}`;
		for (let i = 0; i < 8; i++) {
			code += dict[~~(Math.random() * dict.length)];
		}
		window.localStorage.setItem(`anyhook_code_${store.state.bid}`, code);
		store.state.user?.id && window.localStorage.setItem(`anyhook_uid_${store.state.bid}`, store.state.user.id);
		return code;
	};

	generateCode();

	// loadChats();

	// setup iframe communication
	initIframer();
	onMessage('DRAFT', data => {
		logX('DRAFT', data);
		save('preview', JSON.stringify(data));
		window.location.reload();
	});
	onMessage('ANYHOOK_CODE', data => {
		logX('ANYHOOK_CODE', data);
		localStorage.setItem(`anyhook_code_${store.state.bid}`, data.code);
	});
	onMessage('ANYHOOK_UTM', data => {
		logX('ANYHOOK_UTM', data);
		localStorage.setItem(`anyhook_utm_params_${store.state.bid}`, data.utm);
	});
	sendMessage('READY', {
		user: store.state.user,
		bot: store.state.bot
	});

	if (store.state.bot.style) {
		store.state.bot.style = parseJSON(store.state.bot.style);
		if (store.state.bot.style?.css) {
			const styleTag = document.createElement('style');
			styleTag.innerHTML = store.state.bot.style.css;
			document.head.insertAdjacentElement('beforeend', styleTag);
		}
	}

	if (process.env.VUE_APP_PV_SWITCH == 'ON') requestPV();

	if(store.state.style === 'survey') {
		store.state.noWait = true;
		store.state.noTyping = true;
	}

	new Vue({
		store,
		render: h => h(App)
	}).$mount('#app');

	if(store.state.style) {
		document.querySelector('#app').classList.add(store.state.style);
	}

	if (store.state.bot.js) {
		const htmlDecode = input => {
			const e = document.createElement('textarea');
			e.innerHTML = input;
			return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
		}

		try {
			const code = htmlDecode(store.state.bot.js);
			console.log('Running code', code);
			(0, eval)(code);
		} catch (ex) {
			console.error(ex);
		}
	}
})();
